import React from 'react'
import { IssueEntity } from 'types/IssueEntity'
import { formatDateYYYYMMDD } from '../../../packages/utils/numberFormatters'
import { FactsTableRow } from '../../components/FactsTable'

export function OutcomeDateRow({ issue }: { issue: IssueEntity }) {
    const outcomeDate = issue.sources?.find((s) => s.sourceType === 'Outcome')?.publishedDate
    return <FactsTableRow label='Datum (genomförande)'>{formatDateYYYYMMDD(outcomeDate)}</FactsTableRow>
}
